import { createAction } from '../../utils/reduxUtils';
import { IAsyncError } from '../../common';
import { IUserProfile } from '../../models';

/*
const myAction = createAction('MY_ACTION', action => {
  return (arg: number) => action(arg);
});
*/

const fetchPublicProfileAsync = {
  request: createAction('FETCH_PUBLIC_PROFILE_REQUEST')<string>,
  success: createAction('FETCH_PUBLIC_PROFILE_SUCCESS')<IUserProfile>,
  failure: createAction('FETCH_PUBLIC_PROFILE_FAILURE')<IAsyncError>,
};

const actions = {
  fetchPublicProfileAsync,
};

export default actions;
